import { Card, Label, Modal, RenderControl } from '@fareye/ui'
import React, { useEffect } from 'react'
import {
  DEVICE_CONFIG,
  HEADER_INFLECTION,
  initialState
} from '../../config/constants'
import { get, cancelToken, isEmpty } from '@fareye/utils'
import GpsDeviceTable from './GpsDeviceTable'

export default function GpsHistoryModal({
  selectedDevice,
  setSelectedDevice
}: any) {
  const [gpsDeviceHistory, setGpsDeviceHistory] = React.useState(initialState)
  const { deviceHistoryPathParam } = DEVICE_CONFIG
  const source = cancelToken().source()

  useEffect(() => {
    fetchDevices()
  }, [])

  const fetchDevices = async () => {
    try {
      setGpsDeviceHistory({ ...gpsDeviceHistory, isLoading: true })
      const url = `${deviceHistoryPathParam}?imei=${selectedDevice?.data?.imei}`
      const {
        data: { data }
      } = await get(url, source.token, HEADER_INFLECTION)
      setGpsDeviceHistory({
        ...gpsDeviceHistory,
        data,
        isLoading: false,
        isSuccess: true,
        isError: false,
        message: isEmpty(data) ? 'No Data Found' : ''
      })
    } catch (ex) {
      setGpsDeviceHistory({
        ...gpsDeviceHistory,
        isLoading: false,
        isSuccess: false,
        isError: true,
        message: 'Something went wrong'
      })
      console.error(ex)
    }
  }
  const CardHeader = () => {
    return (
      <Label style={{ padding: '10px 15px' }} variant="h5">
        History for IMEI NO- {selectedDevice?.data?.imei}
      </Label>
    )
  }

  return (
    <Modal
      variant="m drawer Top-Right"
      toggleModal={selectedDevice.openHistoryModal}
      style={{ content: { height: '100%', maxHeight: '100vh' } }}
      setToggleModal={openHistoryModal => {
        setSelectedDevice({
          ...selectedDevice,
          openHistoryModal
        })
      }}
    >
      <Card header={CardHeader()}>
        <RenderControl state={gpsDeviceHistory}>
          <GpsDeviceTable
            setSelectedDevice={setSelectedDevice}
            deviceData={gpsDeviceHistory}
            hideAction={true}
            meta={{
              count: gpsDeviceHistory.data.length,
              perPage: gpsDeviceHistory.data.length
            }}
            key="history-table"
          />
        </RenderControl>
      </Card>
    </Modal>
  )
}
